import QRCode from 'qrcode'
import { LOADER_LOGO_URL } from '@/constants/brandAssets'

let logoImagePromise = null

function loadImage (src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.decoding = 'async'
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

function getLogoImage () {
  if (!logoImagePromise) {
    logoImagePromise = loadImage(LOADER_LOGO_URL).catch(() => null)
  }
  return logoImagePromise
}

function fillRoundRect (ctx, x, y, width, height, radius) {
  const r = Math.min(radius, width / 2, height / 2)
  ctx.beginPath()
  if (typeof ctx.roundRect === 'function') {
    ctx.roundRect(x, y, width, height, r)
  } else {
    ctx.moveTo(x + r, y)
    ctx.arcTo(x + width, y, x + width, y + height, r)
    ctx.arcTo(x + width, y + height, x, y + height, r)
    ctx.arcTo(x, y + height, x, y, r)
    ctx.arcTo(x, y, x + width, y, r)
    ctx.closePath()
  }
  ctx.fill()
}

async function drawCenterLogo (canvas, size) {
  const logo = await getLogoImage()
  if (!logo || !logo.naturalWidth || !logo.naturalHeight) return

  const ctx = canvas.getContext('2d')
  if (!ctx) return

  const logoBox = Math.round(size * 0.24)
  const innerPad = Math.round(logoBox * 0.12)
  const box = logoBox + innerPad * 2
  const boxX = Math.round((size - box) / 2)
  const boxY = Math.round((size - box) / 2)
  const drawSize = logoBox

  // 축소/확대 시 뿌연 느낌 방지
  ctx.imageSmoothingEnabled = false

  ctx.fillStyle = '#FFFFFF'
  fillRoundRect(ctx, boxX, boxY, box, box, Math.round(box * 0.18))

  const srcH = logo.naturalHeight
  const srcW = logo.naturalWidth
  const crop = Math.min(srcH, srcW)
  const sx = 0
  const sy = Math.max(0, (srcH - crop) / 2)

  ctx.drawImage(
    logo,
    sx,
    sy,
    crop,
    crop,
    Math.round(boxX + innerPad),
    Math.round(boxY + innerPad),
    Math.round(drawSize),
    Math.round(drawSize)
  )
}

export async function generateQrDataUrl (text, size = 168) {
  const value = String(text || '').trim()
  if (!value) return ''

  // QR을 2배 해상도로 렌더링하면 로고/라인이 더 선명해짐 (표시 크기는 그대로)
  const dpr = (typeof window !== 'undefined' && window.devicePixelRatio) ? window.devicePixelRatio : 1
  const scale = Math.min(2, Math.max(1, dpr))
  const renderSize = Math.round(size * scale)

  const canvas = document.createElement('canvas')
  await QRCode.toCanvas(canvas, value, {
    width: renderSize,
    margin: 2,
    errorCorrectionLevel: 'H',
    color: {
      dark: '#000000',
      light: '#FFFFFF'
    }
  })

  try {
    await drawCenterLogo(canvas, renderSize)
  } catch (err) {
    // 로고 실패 시 QR만 반환
  }

  return canvas.toDataURL('image/png')
}

export function extractTetherAddress (bankinfo) {
  const raw = String(bankinfo || '').trim()
  if (!raw) return ''
  return raw.replace(/^테더주소\s*안내\s*:\s*/i, '').trim() || raw
}
